import httpClient from '@/http-client'

export const candidateProfileList = data => {
    return httpClient
        .get('/api/reports/candidate-profile-lists', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const examRegistrationList = data => {
    return httpClient
        .get('/api/reports/exam-registration-lists', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const examEvaluationList = data => {
    return httpClient
        .get('/api/reports/exam-evaluation-lists', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const examEvaluationDetail = data => {
    return httpClient
        .get('/api/reports/exam-evaluation-details', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const printOperationList = data => {
    return httpClient
        .get('/api/reports/print-operation-lists', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const formModel = (options = {}) => {
    return httpClient
        .get('/api/reports/form-view-models', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export default { formModel, candidateProfileList, examRegistrationList, examEvaluationList, examEvaluationDetail, printOperationList }